const fonts: { [k: string]: string } = {
  nimbus: 'nimbus-sans, sans-serif',
  monospace:
    'Menlo, "Cascadia Code", "Operator Mono", "Fira Code", "Dank Mono", Consolas, monospace',
}

fonts.body = 'nimbus-sans, sans-serif'
fonts.heading = 'calliope-mvb, serif'


const fontSizes = [14, 16, 20, 24, 32, 36, 48, 54, 64, 108].map(
  (px) => `${px / 16}rem`
)
const fontWeights = {
  book: 300,
  body: 600,
  heading: 700,
  bold: 700,
  xBold: 800,
}
const lineHeights = {
  body: 1.5,
  heading: 1.25,
}
const letterSpacings = {
  body: 'normal',
  caps: '0.2em',
}

export { fonts, fontSizes, fontWeights, lineHeights, letterSpacings }
